import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize theme before rendering to avoid flash
const initializeTheme = () => {
  const theme = localStorage.getItem('theme') || 'dark';
  document.documentElement.setAttribute('data-theme', theme);
};

initializeTheme();

// Mark that the app was reloaded in this session so components like Agent
// can choose to show a one-time animation when opened after a reload.
try {
  const navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
  const nav = Array.isArray(navEntries) && navEntries[0] ? navEntries[0] : null;
  if (nav && nav.type === 'reload') {
    try { sessionStorage.setItem('commandxReloaded', 'true'); } catch (e) { }
  }
} catch (e) {
  // ignore
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();